import React from "react";
import { Link } from "react-router-dom";
import Politicas from "../media/institucional/Política de tratamiento y protección de datos personales.pdf";
import Estados2022 from "../media/institucional/Estados Financieros Año 2022.pdf";
class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false,
            openSections: {
                nosotros: false,
                escuela: false
            }
        };
        this.menuRef = React.createRef();
        this.buttonRef = React.createRef();
        this.firstMenuItem = null;
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.toggleSection = this.toggleSection.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isMenuOpen && this.state.isMenuOpen) {
            document.body.classList.add("menu-open");
            document.addEventListener("mousedown", this.handleDocumentClick);
            document.addEventListener("touchstart", this.handleDocumentClick, { passive: true });
            document.addEventListener("keydown", this.handleKeyDown);
            this.focusFirstMenuItem();
        } else if (prevState.isMenuOpen && !this.state.isMenuOpen) {
            document.body.classList.remove("menu-open");
            document.removeEventListener("mousedown", this.handleDocumentClick);
            document.removeEventListener("touchstart", this.handleDocumentClick);
            document.removeEventListener("keydown", this.handleKeyDown);
            if (this.buttonRef.current) {
                this.buttonRef.current.focus();
            }
        }
    }

    componentWillUnmount() {
        document.body.classList.remove("menu-open");
        document.removeEventListener("mousedown", this.handleDocumentClick);
        document.removeEventListener("touchstart", this.handleDocumentClick);
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    focusFirstMenuItem() {
        if (!this.menuRef.current) return;
        const focusables = this.menuRef.current.querySelectorAll(
            "a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])"
        );
        if (focusables.length > 0) {
            this.firstMenuItem = focusables[0];
            this.firstMenuItem.focus();
        }
    }

    handleDocumentClick(event) {
        if (!this.state.isMenuOpen || !this.menuRef.current) return;
        if (this.menuRef.current.contains(event.target)) {
            return;
        }
        if (this.buttonRef.current && this.buttonRef.current.contains(event.target)) {
            return;
        }
        this.closeMenu();
    }

    handleKeyDown(event) {
        if (!this.state.isMenuOpen) return;
        if (event.key === "Escape") {
            this.closeMenu();
            return;
        }
        if (event.key !== "Tab" || !this.menuRef.current) return;
        const focusables = this.menuRef.current.querySelectorAll(
            "a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])"
        );
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    toggleMenu() {
        this.setState((prevState) => ({ isMenuOpen: !prevState.isMenuOpen }));
    }

    closeMenu() {
        this.setState({ isMenuOpen: false });
    }

    toggleSection(sectionKey) {
        this.setState((prevState) => ({
            openSections: {
                ...prevState.openSections,
                [sectionKey]: !prevState.openSections[sectionKey]
            }
        }));
    }

    render() {

        return (
            <React.Fragment>
                <button
                    className="burger-button phone-only"
                    onClick={this.toggleMenu}
                    aria-expanded={this.state.isMenuOpen ? "true" : "false"}
                    aria-controls="mobile-menu"
                    aria-label={this.state.isMenuOpen ? "Cerrar menu" : "Abrir menu"}
                    ref={this.buttonRef}
                >
                    <i className="fa fa-bars"></i>
                </button>
                {this.state.isMenuOpen && (
                <div className="menu-overlay" role="dialog" aria-modal="true" aria-label="Menu de navegacion" onClick={this.closeMenu}>
                <ul className={"nav-bar phone-only"} id="mobile-menu" ref={this.menuRef} onClick={(event) => event.stopPropagation()}>
                    <Link to={"./creaciones"} onClick={this.closeMenu}>
                        <li>
                            <h1>Creaciones</h1>
                        </li>
                    </Link>
                    <li className={`dropdown${this.state.openSections.nosotros ? " is-open" : ""}`}>
                        <h1
                            className="dropbtn"
                            role="button"
                            tabIndex={0}
                            aria-expanded={this.state.openSections.nosotros ? "true" : "false"}
                            aria-controls="mobile-nosotros"
                            onClick={() => this.toggleSection("nosotros")}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    this.toggleSection("nosotros");
                                }
                            }}
                        >
                            Nosotros
                            <i className="fa fa-caret-down" />
                        </h1>
                        <div className="dropdown-content" id="mobile-nosotros">
                            <Link to={"./Grupo"} onClick={this.closeMenu}>Grupo</Link>
                            <Link to={"./Historia"} onClick={this.closeMenu}>Historia</Link>
                            <Link to={"./Sede"} onClick={this.closeMenu}>Sede</Link>
                            <Link to={"./Publicaciones"} onClick={this.closeMenu}>Publicaciones</Link>
                            <Link to={"./institucional"} onClick={this.closeMenu}>Institucional</Link>
                        </div>
                    </li>
                    <Link to={"./director"} onClick={this.closeMenu}>
                        <li>
                            <h1>
                                Director
                            </h1>
                        </li>
                    </Link>
                    <Link to={"./Noticias"} onClick={this.closeMenu}>
                        <li>
                            <h1>
                                Noticias
                            </h1>
                        </li>
                    </Link>
                    <Link to={"./Calendario"} onClick={this.closeMenu}>
                        <li>
                            <h1>
                                Programacion
                            </h1>
                        </li>
                    </Link>
                    <li className={`dropdown${this.state.openSections.escuela ? " is-open" : ""}`}>
                        <h1
                            className="dropbtn"
                            role="button"
                            tabIndex={0}
                            aria-expanded={this.state.openSections.escuela ? "true" : "false"}
                            aria-controls="mobile-escuela"
                            onClick={() => this.toggleSection("escuela")}
                            onKeyDown={(event) => {
                                if (event.key === "Enter" || event.key === " ") {
                                    event.preventDefault();
                                    this.toggleSection("escuela");
                                }
                            }}
                        >
                            Escuela Itinerante
                            <i className="fa fa-caret-down" />
                        </h1>
                        <div className="dropdown-content" id="mobile-escuela">
                            <Link to={"./talleres"} onClick={this.closeMenu}>Talleres teatrales</Link>
                            <Link to={"./memoria-y-comunidad"} onClick={this.closeMenu}>Memoria</Link>
                            <Link to={"./procesos-creacion"} onClick={this.closeMenu}>Procesos Creación</Link>
                        </div>
                    </li>
                </ul>
                </div>
                )}

                <div className="menu-desktop-only">
                    <ul className={"nav-bar desktop-only"}>
                        <Link to={"./creaciones"}>
                            <li>
                                <h1>Creaciones</h1>
                            </li>
                        </Link>
                        <li className="dropdown">
                            <h1 className="dropbtn">
                                Nosotros
                                <i className="fa fa-caret-down" />
                            </h1>
                            <div className="dropdown-content">
                                <Link to={"./Grupo"}>Grupo</Link>
                                <Link to={"./Historia"}>Historia</Link>
                                <Link to={"./Sede"}>Sede</Link>
                                <Link to={"./Publicaciones"}>Publicaciones</Link>
                                <Link to={"./institucional"}>Institucional</Link>
                            </div>
                        </li>
                        <Link to={"./director"}>
                            <li>
                                <h1>Director</h1>
                            </li>
                        </Link>
                        <Link to={"./Noticias"}>
                            <li>
                                <h1>Noticias</h1>
                            </li>
                        </Link>
                        <Link to={"./Calendario"}>
                            <li>
                                <h1>Programacion</h1>
                            </li>
                        </Link>

                        <li className="dropdown">
                            <h1 className="dropbtn">
                                Escuela Itinerante
                                <i className="fa fa-caret-down" />
                            </h1>
                            <div className="dropdown-content">
                                <Link to={"./talleres"}>Talleres teatrales</Link>
                                <Link to={"./memoria-y-comunidad"}>Memoria y Comunidad</Link>
                                <Link to={"./procesos-creacion"}>Procesos de Creación</Link>

                            </div>

                        </li>
                    </ul>
                </div>


            </React.Fragment>
        );
    }
}

export default NavBar;
